import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTagChevronIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "TagChevron",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M12.9773 6.51438L10.6444 3.01437C10.5645 2.89459 10.4562 2.79638 10.3292 2.72846C10.2023 2.66053 10.0605 2.625 9.91648 2.625H1.3125C1.23268 2.625 1.15439 2.64684 1.08609 2.68814C1.01779 2.72945 0.962095 2.78866 0.925032 2.85935C0.887969 2.93004 0.87095 3.00952 0.875819 3.08919C0.880689 3.16886 0.90726 3.24568 0.952656 3.31133L3.5 7L0.952656 10.6887C0.90726 10.7543 0.880689 10.8311 0.875819 10.9108C0.87095 10.9905 0.887969 11.07 0.925032 11.1407C0.962095 11.2113 1.01779 11.2705 1.08609 11.3119C1.15439 11.3532 1.23268 11.375 1.3125 11.375H9.91648C10.0605 11.375 10.2023 11.3395 10.3292 11.2715C10.4562 11.2036 10.5645 11.1054 10.6444 10.9856L12.9773 7.48563C13.0733 7.34184 13.1245 7.17285 13.1245 7C13.1245 6.82715 13.0733 6.65816 12.9773 6.51438ZM9.91484 10.5H2.14648L4.22461 7.49219L4.22898 7.48672C4.32492 7.34293 4.37612 7.17395 4.37612 7.00109C4.37612 6.82824 4.32492 6.65926 4.22898 6.51547L4.22461 6.51L2.14648 3.50219H9.91648L12.25 7L9.91484 10.5Z",
			fill: "currentColor"
		})
	})
});
export default SvgTagChevronIcon;
